import { overlayActions } from '../_actions';

const overlayCreators = overlayActions;

export default overlayCreators;